import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';
import './styles.css';

export default function InfoPage() {
  const { t } = useTranslation(['info', 'common']);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <SEO
        title={t('info:seo.title')}
        description={t('info:seo.description')}
        keywords={t('info:seo.keywords')}
        ogImage="https://public.readdy.ai/ai/img_res/77c3aa1b9f506a58306b004960ddf286.jpg"
      />
      <Navigation />

      <div className="pt-20 sm:pt-32 pb-14 sm:pb-20 px-5 sm:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-16">
            <h1 className="text-2xl sm:text-4xl md:text-6xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('info:hero.title')}
            </h1>
            <div className="w-16 sm:w-24 h-px bg-[#8B9D83] mx-auto mb-5 sm:mb-8"></div>
            <p className="text-sm sm:text-lg font-light text-gray-600 leading-relaxed">
              {t('info:hero.description')}
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-8 sm:space-y-12">
            {/* Section 1 */}
            <section className="bg-white p-6 sm:p-10 rounded-sm shadow-sm">
              <h2 className="text-xl sm:text-3xl font-light text-[#4A5D44] mb-4 sm:mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                {t('info:section1.title')}
              </h2>
              <p className="text-sm sm:text-base leading-relaxed text-gray-700 font-light mb-4">
                {t('info:section1.paragraph1')}
              </p>
              <p className="text-sm sm:text-base leading-relaxed text-gray-700 font-light">
                {t('info:section1.paragraph2')}
              </p>
            </section>

            {/* Section 2 */}
            <section className="bg-white p-6 sm:p-10 rounded-sm shadow-sm">
              <h2 className="text-xl sm:text-3xl font-light text-[#4A5D44] mb-4 sm:mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                {t('info:section2.title')}
              </h2>
              <ul className="space-y-3 sm:space-y-4">
                {[
                  t('info:section2.item1'),
                  t('info:section2.item2'),
                  t('info:section2.item3'),
                  t('info:section2.item4'),
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-[#8B9D83] text-lg sm:text-xl flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
                    <span className="text-sm sm:text-base leading-relaxed text-gray-700 font-light">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 3 */}
            <section className="bg-white p-6 sm:p-10 rounded-sm shadow-sm">
              <h2 className="text-xl sm:text-3xl font-light text-[#4A5D44] mb-4 sm:mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                {t('info:section3.title')}
              </h2>
              <p className="text-sm sm:text-base leading-relaxed text-gray-700 font-light mb-4">
                {t('info:section3.paragraph1')}
              </p>
              <p className="text-sm sm:text-base leading-relaxed text-gray-700 font-light">
                {t('info:section3.paragraph2')}
              </p>
            </section>
          </div>

          {/* CTA Section */}
          <div className="mt-10 sm:mt-16 text-center bg-gradient-to-r from-[#8B9D83]/10 to-[#B8D4A8]/10 rounded-lg p-6 sm:p-12">
            <h2 className="text-xl sm:text-3xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('info:cta.title')}
            </h2>
            <p className="text-sm sm:text-lg font-light text-gray-600 mb-5 sm:mb-8 max-w-2xl mx-auto">
              {t('info:cta.description')}
            </p>
            <Link
              to="/payment"
              className="inline-block px-7 sm:px-12 py-3 sm:py-4 bg-[#8B9D83] text-white text-xs sm:text-sm font-light tracking-widest uppercase rounded-sm hover:bg-[#7A8C72] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              aria-label={t('info:cta.buttonAria')}
            >
              {t('info:cta.button')}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}